import counterBottom from "../__utils/number-counter";
import { counterMiddle } from "../__utils/number-counter";
import CircularLoader from "../__utils/circular-loader";
import ScreenLock from "../__constants/lock-screen";

class OpenMenuItem {
    constructor(item, section, sectionBackground, articleInfo, singleProdOverlay) {
        this.item = item;
        this.section = section;
        this.sectionBackground = sectionBackground;
        this.articleInfo = articleInfo;
        this.singleProdOverlay = singleProdOverlay;
    }
    openItem(e) {
        const mobileViewport = window.matchMedia(
            "screen and (min-width: 768px)"
        );

        const section = document.querySelector(this.section);
        const element = e.currentTarget;
        let list = [];
        const offsetRight =
            section.offsetWidth - element.offsetLeft - element.offsetWidth;

        if (mobileViewport.matches) {

            if (!e.currentTarget.classList.contains("is-open")) {

                if (offsetRight <= 0) {
                    list = ["is-open", "is-open-left"];
                } else {
                    list = ["is-open", "is-open-right"];
                }
                for (let i = 0; i < list.length; i++) {
                    e.currentTarget.classList.add(list[i]);
                }
                section.classList.add("item-is-open");
            }
        } else {
            const activeItem = e.currentTarget;
            const itemClone = activeItem.cloneNode(true);
            const singleProdOverlay = document.querySelector(
                this.singleProdOverlay
            );

            singleProdOverlay.classList.add("is-active");

            if (singleProdOverlay.children[1]) {
                singleProdOverlay.removeChild(singleProdOverlay.children[1]);
                singleProdOverlay.appendChild(itemClone);
            } else {
                singleProdOverlay.appendChild(itemClone);
            }
            ScreenLock.lock();
        }
    }
    closeItem() {
        const section = document.querySelector(this.section);
        let tileItems = document.querySelectorAll(this.item);
        if (tileItems) {
            tileItems = Array.prototype.slice.call(tileItems);
            tileItems.forEach(element => {
                if (element.classList.contains("is-open")) {
                    element.classList.remove("is-open");
                    section.classList.remove("item-is-open");
                }
                if (element.classList.contains("is-open-right")) {
                    element.classList.remove("is-open-right");
                }
                if (element.classList.contains("is-open-left")) {
                    element.classList.remove("is-open-left");
                }
            });
        }
    }
    closeProdOverlay(e) {
        const closeBtn = e.currentTarget;
        const singleProdOverlay = closeBtn.parentNode;
        singleProdOverlay.classList.remove("is-active");
        ScreenLock.unlock();
    }
    itemHeights(element) {
        const bottomRowWrap = element.querySelector(".bottom-row-wrap");
        const bottomRowHeight = bottomRowWrap.offsetHeight;
        let barsBottom = element.querySelectorAll(".bar-bottom");

        if (barsBottom) {
            barsBottom = Array.prototype.slice.call(barsBottom);
            barsBottom.forEach(barBottom => {
                barBottom.style.minHeight = bottomRowHeight + "px";
            });
        }
    }
    equalizeItemHeights() {
        let tileItems = document.querySelectorAll(".menu-grid .column-3");
        if (tileItems) {
            tileItems = Array.prototype.slice.call(tileItems);
            tileItems.forEach(element => {
                this.itemHeights(element);
            });
        }
    }
    init() {
        let tileItems = document.querySelectorAll(this.item);
        const sectionBackground = document.querySelector(this.sectionBackground);
        let articleInfo = document.querySelectorAll(this.articleInfo);
        const singleProdOverlay = document.querySelector(this.singleProdOverlay);
        let singleProdClose;
        if (singleProdOverlay) {
            singleProdClose = singleProdOverlay.querySelector(".article-close");
        }

        if (tileItems) {
            tileItems = Array.prototype.slice.call(tileItems);
            tileItems.forEach(element => {
                this.itemHeights(element);
                element.addEventListener("click", e => {
                    this.openItem(e);
                });

            });
        }

        if (sectionBackground) {
            sectionBackground.addEventListener("click", () => {
                this.closeItem();
            });
        }
        if (singleProdClose) {
            singleProdClose.addEventListener("click", e => {
                this.closeProdOverlay(e);
            });
        }
        if (singleProdOverlay) {
            singleProdOverlay.addEventListener("transitionend", e => {
                counterBottom.init();
                counterMiddle.init();
                CircularLoader.init();
            });
        }
        if (articleInfo) {
            articleInfo = Array.prototype.slice.call(articleInfo);
            articleInfo.forEach(element => {
                element.addEventListener("transitionend", e => {
                    counterBottom.init();
                    counterMiddle.init();
                    CircularLoader.init();
                });
            });
        }
    }
}

export default new OpenMenuItem(".menu-grid .column-3", ".menu-grid", ".products-overlay", ".article-info", ".single-prod-over"
);
